<template>
    <div class="home">
        <div class="mid_box">
            <div class="mid_frame">
                <div :class="isChooseLeft ?'tag_left_current': 'tag_left_default'" @click="isChooseLeft = true">
                    <span>领取地铁票</span>
                    <i></i><s></s>
                </div>
                <div :class="!isChooseLeft ?'tag_right_current': 'tag_right_default'"
                     @click="$router.push({ path: '/cardslist'  ,query: $route.query})">
                    <span>票卡列表</span>
                    <i></i><s></s>
                </div>
            </div>
            <div class="main-exchange input_area">
                <div class="main-exchange-tab1" v-show="isChooseLeft">
                    <div class="input_frame">
                        <div class="input_box">
                            <span>兑换码</span>
                            <input class="fill_in01" type="text" placeholder="输入兑换码" onfocus="this.placeholder=''"
                                   v-model="form.InputCode"
                                   onblur="this.placeholder='输入兑换码'"/>
                        </div>
                    </div>
                    <p class="agreement">
                        领取代表您已同意
                        <a href="https://ucityapp.xzsmartmetro.com/v1.1.9/XZmetro_app_H5/source/mouldboard/Agreement.html">《宁波地铁用户协议》</a>
                    </p>
                    <a class="btn_receive " @click="onSubmit">立即领取</a>
                </div>
                <div class="main-exchange-tab2" v-show="isChooseLeft"></div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  data () {
    return {
      input: '',
      form: { 'Mobilephone': '', 'InputCode': '', 'Passcode': '' },
      isChooseLeft: true,
      hadGotCode: false,
      GotCodeText: '获取验证码',
      isLoadingGetCode: false,
      isShowExchange: true
    }
  },
  beforeMount () {

  },
  mounted () {
    this.mdui.mutation()
  },
  computed: {},
  methods: {
    onSubmit () {
      if (this.$store.state.Token) {
        this.exchange()
      } else {
        this.mdui.snackbar({
          message: '请先登录',
          position: 'bottom'
        })
      }
      // if (this.form.Passcode.length < 6) {
      //   this.mdui.snackbar({
      //     message: '请输入正确的验证码！',
      //     position: 'bottom'
      //   })
      //   return
      // }
    },
    exchange () {
      this.$axios.post('/itps/api/coupon/reward', { InputCode: this.form.InputCode })
        .then(data => {
          if (data && data.Code === 200) {
            let guid = data.Data.Guid
            this.mdui.dialog({
              title: '提示',
              content: '兑换成功！',
              history: false,
              buttons: [
                {
                  text: '确认',
                  onClick: inst => {
                    setTimeout(_ => {
                      let q = this.$route.query
                      q['guid'] = guid
                      this.$router.push({ path: '/preview', query: q })
                    }, 200)
                  }
                }
              ]
            })
          } else if (data.Code === -404) {
            this.mdui.snackbar({
              message: '网络错误',
              position: 'bottom'
            })
          } else if (data.Code === 4702) {
            this.mdui.snackbar({
              message: '兑换码错误',
              position: 'bottom'
            })
          } else {
            this.mdui.snackbar({
              message: data.Message,
              position: 'bottom'
            })
          }
        })
    },
    login () {
      return new Promise((resolve, reject) => {
        if (this.form.Passcode.length < 6) {
          reject(new Error('请登录并输入正确信息'))
          return
        }
        this.$axios
          .post('ucity/user/open/login', {
            DeviceType: '7',
            LoginName: this.form.Mobilephone,
            Passcode: this.form.Passcode,
            RegistrationId: ''
          })
          .then(data => {
            if (data && data.Code === 200) {
              this.$store.commit('setToken', data.Data.Token)
              resolve()
            } else if (data.Code === -404) {
              reject(new Error('网络错误'))
            } else {
              reject(new Error(data.Message))
            }
          })
      })
    },
    startCountDown (text) {
      if (text) this.GotCodeText = text
      if (this.GotCodeText === '获取验证码') {
        this.GotCodeText = '60s'
        this.setCountDownNext()
      } else if (/\d+s/.test(this.GotCodeText)) {
        let second = this.GotCodeText.match(/\d+/)[0]
        if (second === 1) {
          this.stopCountDown()
        } else {
          this.GotCodeText = second - 1 + 's'
          this.setCountDownNext()
        }
      }
    },
    stopCountDown () {
      this.hadGotCode = false
      this.GotCodeText = '获取验证码'
    },
    setCountDownNext () {
      setTimeout(() => this.startCountDown(), 1000)
    },
    handleGetPassCode: function () {
      // 获取验证码
      if (this.hadGotCode || this.form.Mobilephone.length < 11) return
      this.isLoadingGetCode = true
      this.$axios
        .post('/ucity/push/passcode/mobilephone', { 'Mobilephone': this.form.Mobilephone })
        .then(data => {
          if (data && data.Code === 200) {
            this.hadGotCode = true
            this.startCountDown()
            this.mdui.snackbar({
              message: '发送验证码成功！',
              position: 'bottom'
            })
          } else if (data.Code === -404) {

          } else {
            let errMessage = data.Message
            if (errMessage.includes('invalid mobile number')) {
              errMessage = '请输入正确的手机号码！'
            } else if (errMessage.includes('PUSHPASSCODETOMOBILEPHONE FAILD!')) {
              errMessage = '获取验证码失败，请稍后重试！'
            }
            this.mdui.snackbar({
              message: errMessage,
              position: 'bottom'
            })
          }
        })
        .finally(_ => {
          this.isLoadingGetCode = false
        }).catch(e => console.log(e))
    }
  }
}
</script>

<style scoped>

    .home {
        height: 100%;
        background-image: url(/img/bg_all.png);
        background-size: 100%;
        background-repeat: no-repeat;
        background-color: #036adf;
    }

    .mid_box {
        width: 90%;
        overflow: hidden;
        padding-left: 5%;
        padding-right: 5%;
        padding-top: 90px;
    }

    .mid_box .mid_frame {
        width: 100%;
        overflow: hidden;
        height: 50px;
        float: left;
    }

    .mid_box .mid_frame .tag_left_current {
        display: block;
        width: 55%;
        float: left;
        height: 50px;
        background-color: #f4f8ff;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        position: relative;
    }

    .mid_box .mid_frame .tag_left_current span {
        display: block;
        width: 100%;
        font-size: 17px;
        color: #454545;
        font-weight: bold;
        line-height: 42px;
        margin-top: 8px;
        text-align: center;
    }

    .mid_box .mid_frame .tag_left_current i {
        display: block;
        width: 26px;
        height: 14px;
        background-color: #f4f8ff;
        position: absolute;
        right: 0px;
        bottom: 0px;
    }

    .mid_box .mid_frame .tag_left_current s {
        display: block;
        width: 30px;
        height: 16px;
        border-bottom-right-radius: 10px;
        background-color: #f4f8ff;
        position: absolute;
        right: 0px;
        bottom: 0px;
    }

    .mid_box .mid_frame .tag_right_default {
        display: block;
        width: 45%;
        float: left;
        height: 42px;
        margin-top: 8px;
        background-color: #3e71d0;
        border-top-right-radius: 8px;
        position: relative;
    }

    .mid_box .mid_frame .tag_right_default span {
        display: block;
        width: 100%;
        font-size: 14px;
        font-weight: bold;
        line-height: 42px;
        text-align: center;
        color: #b4cdfd;
    }

    .mid_box .mid_frame .tag_right_default i {
        display: block;
        width: 26px;
        height: 14px;
        background-color: #f4f8ff;
        position: absolute;
        left: 0px;
        bottom: 0px;
    }

    .mid_box .mid_frame .tag_right_default s {
        display: block;
        width: 30px;
        height: 16px;
        background-color: #3e71d0;
        border-bottom-left-radius: 10px;
        position: absolute;
        left: 0px;
        bottom: 0px;
    }

    .mid_box .mid_frame .tag_right_current {
        display: block;
        width: 55%;
        float: left;
        height: 50px;
        background-color: #F4F8FF;
        border-top-right-radius: 8px;
        border-top-left-radius: 8px;
        position: relative;
    }

    .mid_box .mid_frame .tag_right_current span {
        display: block;
        width: 100%;
        font-size: 17px;
        font-weight: bold;
        line-height: 42px;
        margin-top: 8px;
        text-align: center;
        color: #454545;
    }

    .mid_box .mid_frame .tag_right_current i {
        display: block;
        width: 26px;
        height: 14px;
        background-color: #f4f8ff;
        position: absolute;
        left: 0px;
        bottom: 0px;
    }

    .mid_box .mid_frame .tag_right_current s {
        display: block;
        width: 30px;
        height: 16px;
        background-color: #f4f8ff;
        border-bottom-left-radius: 10px;
        position: absolute;
        left: 0px;
        bottom: 0px;
    }

    .mid_box .mid_frame .tag_left_default {
        display: block;
        width: 45%;
        float: left;
        height: 42px;
        margin-top: 8px;
        background-color: #3E71D0;
        border-top-left-radius: 8px;
        position: relative;
    }

    .mid_box .mid_frame .tag_left_default span {
        display: block;
        width: 100%;
        font-size: 14px;
        color: #B4CDFD;
        font-weight: bold;
        line-height: 42px;
        text-align: center;
    }

    .mid_box .mid_frame .tag_left_default i {
        display: block;
        width: 26px;
        height: 14px;
        background-color: #F4F8FF;
        position: absolute;
        right: 0px;
        bottom: 0px;
    }

    .mid_box .mid_frame .tag_left_default s {
        display: block;
        width: 30px;
        height: 16px;
        border-bottom-right-radius: 10px;
        background-color: #3E71D0;
        position: absolute;
        right: 0px;
        bottom: 0px;
    }

    .mid_box .input_area {
        float: left;
        width: 88%;
        padding-left: 6%;
        padding-right: 6%;
        overflow: hidden;
        padding-top: 25px;
        padding-bottom: 20px;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        background-color: #F4F8FF;
    }

    .mid_box .input_area .input_frame {
        width: 100%;
        overflow: hidden;
        height: 54px;
        position: relative;
        float: left;
        margin-bottom: 12px;
    }

    .mid_box .input_area .input_frame .input_box {
        width: 100%;
        padding-left: 4%;
        padding-right: 4%;
        overflow: hidden;
        border-radius: 6px;
        border: 1px solid #c1cdd9;
        height: 44px;
        box-sizing: border-box;
        margin-top: 10px;
    }

    .mid_box .input_area .input_frame span {
        display: block;
        width: 50px;
        height: 19px;
        position: absolute;
        top: 0px;
        left: 15px;
        background-color: #F4F8FF;
        text-align: center;
        line-height: 20px;
        font-size: 11px;
        color: #7f92a5;
    }

    .mid_box .input_area .input_frame .input_box .fill_in01 {
        display: block;
        width: 100%;
        height: 24px;
        padding-top: 10px;
        padding-bottom: 10px;
        background-color: #F4F8FF;
        font-size: 15px;
        color: #454545;
    }

    .mid_box .input_area .input_frame .input_box .fill_in01::placeholder {
        color: #C1CDD9;
    }

    .agreement {
        display: block;
        width: 100%;
        text-align: center;
        font-size: 13px;
        color: #7F92A5;
        float: left;
        margin-top: 30px;
    }

    .agreement a {
        color: #479ced;
    }

    .btn_receive {
        float: left;
        display: block;
        width: 100%;
        height: 44px;
        border-radius: 6px;
        text-align: center;
        line-height: 44px;
        font-size: 15px;
        margin-top: 15px;
        background: -webkit-linear-gradient(left, #50aef5, #3e89e5);
        color: #fff;
        margin-bottom: 15px;
    }

    .btn_getcode {
        display: block;
        width: 35%;
        height: 44px;
        font-size: 14px;
        color: #479CED;
        text-align: center;
        line-height: 44px;
        position: absolute;
        right: 0px;
        top: 10px;
    }

    .btn_getcode_expired {
        color: #AAA !important;
    }

    .main-exchange {
        /*min-height: 300px;*/
    }

    .enter_area {
        width: 88%;
        margin-left: 6%;
        margin-right: 6%;
        overflow: hidden;
        height: 34px;
        float: left;
        margin-top: 20px;
    }

    .enter_area li {
        width: 29.333333%;
        margin-left: 2%;
        margin-right: 2%;
        float: left;
        height: 34px;
        overflow: hidden;
        border-radius: 34px;
        background-color: #265dc4;
        text-align: center;
        line-height: 34px;
        color: #d7eaff;
    }

</style>

<style>
    .mdui-dialog-actions .mdui-btn {
        color: #3e89e5;
    }
</style>
